module.exports = __webpack_public_path__ + "img/illustration.f004da06.svg";